import { APIKit } from "config/axios";
import { ServerConstants } from "constant";

const { API_V1_AGENT_BREAK_START, API_V1_AGENT_STATUS } = ServerConstants;

export interface AgentStatusResponse {
  status: string;
}

export async function agentStatus() {
  const response = await APIKit.get(API_V1_AGENT_STATUS);
  return response.data as AgentStatusResponse;
}

export async function agentBreakStart() {
  const response = await APIKit.post(API_V1_AGENT_BREAK_START);
  return response.data;
}
